/* instanbul ignore file */

import foEuDesignTokens from '@deliveryhero/pd-bento-design-tokens/web/js/fo-eu';
import fpDesignTokens from '@deliveryhero/pd-bento-design-tokens/web/js/fp';

export const generateBentoTokenString = (entity: GlobalEntity): string => {
  let designTokens = fpDesignTokens;

  if (entity.code === 'FO') {
    designTokens = foEuDesignTokens;
  }

  return Object.keys(designTokens).reduce(
    (prev, colorKey) =>
      `${prev} --${colorKey}: ${
        designTokens[colorKey as keyof typeof designTokens]
      };`,
    ''
  );
};
